import { hc } from 'hono/client';

import { AppType } from '@pages/api/v2/[[...route]]';

export const api = hc<AppType>('/').api.v2;
